/// <reference path="../../../../core/directives/searchbar/searchbardirective.ts" />



import '../templates/requestList.scss';
import { TransportMode } from '../models/transportMode';
import { Requestor } from '../models/requestor';
import { IRequestListService } from '../services/requestListService';
import { RequestField } from '../models/RequestField';

import { requestsState } from '../../requests/requestsState';
import { requestDetailState } from '../../requestDetail/states/requestDetailState';
import { addRequestState } from '../../addRequest/states/addRequestState';

import { ListController } from '../../../../core/list/listController';
import { IExceptionalService } from '../../../../core/exceptionalService';
import { IMessageService } from '../../../../core/messageService';


import {requestDetailEditState} from "../../requestDetailEdit/states/requestDetailEditState";

import { NavigationService } from '../../../navigation/navigationService';
import { UserInfoService } from '../../../userInfo/services/UserInfoService';


export class RequestListController extends ListController<RequestField> {
    static $inject = [
        'requestListService', '$state', '$stateParams', '$mdMedia', '$scope', 'ExceptionalService', 'MessageService',
        'NavigationService', 'UserInfoService', '$mdDialog'
    ];

    private _transportModes: TransportMode[];
    private _requestors: Requestor[];
    private _requestFields: RequestField[];
    private _selectedRequestField: RequestField;
    private _isApplyButtonDisabled: boolean;

    isSearchOpen = false;
    isFilterOpen: boolean;
    selectedTransportMode: TransportMode;
    selectedRequestor: Requestor;
    filters: string[] = [];
   
    isSearchAllRequestsButtonAllowedForUser : boolean = false;

    constructor(private _requestlistservice: IRequestListService,
        protected _$state: angular.ui.IStateService,
        private _$stateParams: angular.ui.IStateParamsService,
        protected _$mdMedia: angular.material.IMedia,
        protected _$scope: angular.IScope,
        protected _exceptionalService: IExceptionalService,
        private _messageService: IMessageService,
        private _navigationService: NavigationService,
        private _userInfoService: UserInfoService,
        private $mdDialog: angular.material.IDialogService
    ) {

        super(_$scope, _$mdMedia, _$state, _exceptionalService);
    }

    $onInit(): void {
        super.$onInit();
        this.isLoading = true;
        this._isApplyButtonDisabled = true;
        this.loadingFilterOptionsBasedonRole();
        this.loadItems();
    }

    loadingFilterOptionsBasedonRole(): void {

        this._$scope.$watch(() => { return UserInfoService.stuInfo; },
            (newValue, oldValue) => {
                if (newValue !== undefined && newValue.role.indexOf("receiver") >= 0) {
                    this._requestlistservice.getTransportModeFilterOptions()
                        .then(o => this.handleGetTransportModeOptions(o));
                    this._requestlistservice.getRequestorFilterOptions().then(o => this.handleGetRequestorOptions(o));
                    this.loadItems();
                }
                else if (newValue !== undefined) {
                    this.isSearchAllRequestsButtonAllowedForUser = true;
                }
            });
    }


    openFilter(): void {
        this.isFilterOpen = true;
    }

    closeFilter(): void {
        this.isFilterOpen = false;

        this.selectedTransportMode = this.filters.length > 0 ? this.selectedTransportMode : null;
        this.selectedRequestor = this.filters.length > 0 ? this.selectedRequestor : null;


    }

    

    applyFilter(): void {

        this.filters = [];

        if (this.selectedTransportMode !== undefined && this.selectedTransportMode !== null) {
            this.filters.push(this.selectedTransportMode.tMCode);
        }

        if (this.selectedRequestor !== undefined && this.selectedRequestor !== null) {
            this.filters.push(this.selectedRequestor.rqCode);
        }
        this.reloadList();
    }

    resetFilter(value: string): void {

        this.filters = this.filters.filter(item => item !== value);
        var existingFilterValue = '';

        if (this.filters.length > 0) {
            existingFilterValue = this.filters[0];
        }

        this.selectedTransportMode = null;
        for (let x of this.transportModes) {
            if (x.tMCode === existingFilterValue) {
                this.selectedTransportMode = x;
            }
        }

        this.selectedRequestor = null;
        for (let item of this.requestors) {
            if (item.rqCode === existingFilterValue) {
                this.selectedRequestor = item;
            }
        }


        this.filterSelectedValueChanged();
        this.reloadList();
    }

    filterSelectedValueChanged(): void {

        if ((this.selectedRequestor !== undefined && this.selectedRequestor !== null) ||
            (this.selectedTransportMode !== undefined && this.selectedTransportMode !== null)) {
            this._isApplyButtonDisabled = false;
        } else {
            this._isApplyButtonDisabled = true;
        }
    }

    private reloadList(): void {
        this.goToList()
            .then(() => this.loadItems());
    }

    get showToolbarMenu(): boolean {
        return (this._$mdMedia('xs') || this._$mdMedia('sm'));
    }
    get hideList(): boolean {

        let shouldHide = false;
        if ((this._$mdMedia('xs') || this._$mdMedia('sm')) &&
            (this._userInfoService.getUserInfo().role.indexOf("receiver") >= 0 ?
                this._$state.is(requestDetailEditState.name) : this._$state.is(requestDetailState.name))) {
            shouldHide = true;
        }

        return shouldHide;
    }


    get requestField(): RequestField[] {
        return this._requestFields;
    }

    get selectedRequestField(): RequestField {
        return this._selectedRequestField;
    }


    protected goToDetailState(item: RequestField): angular.IPromise<any> {
        

        if (this._userInfoService.getUserInfo().role.indexOf("receiver") >= 0) {
            return this._$state.go(requestDetailEditState.name, { trackingId: item.trackingId });
        } else {
            return this._$state.go(requestDetailState.name, { trackingId: item.trackingId });
        }

    }

   

protected goToListState(): angular.IPromise<any> {
        return this._$state.go(requestsState.name);
    }

public openPopUp(): angular.IPromise<any> {
  const dialogTemplate = `
  <md-dialog>
    <style>
      .dialog-content {
        color: #333;
        font-family: Arial, sans-serif;
        padding: 20px;
      }
      .dialog-link {
        color: #1a73e8;
        text-decoration: none;
      }
      .dialog-link:hover {
        text-decoration: underline;
      }
      .md-dialog-actions {
        text-align: right;
        padding: 16px;
      }
      .md-dialog-actions .md-button.ok-button {
        background-color: rgb(67, 160, 71) !important;
        color: white !important; 
        text-transform: none !important; 
        border-radius: 4px !important; 
        padding: 8px 16px !important; 
      }
      .md-dialog-actions .md-button.ok-button:hover {
        background-color: rgb(56, 142, 60) !important; 
        color: white !important; 
      }
      .md-dialog-header {
        position: relative;
        padding: 16px;
        border-bottom: 1px solid #ddd;
      }
      .md-dialog-close {
        position: absolute;
        top: 8px;
        right: 8px;
        width: 24px;
        height: 24px;
        background: rgba(0, 0, 0, 0);
        border: none;
        border-radius: 50%;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .md-dialog-close::before {
        content: '✖';
        font-size: 16px;
        color: #333;
      }
      .md-dialog-close:hover {
        background: rgba(0, 0, 0, 0.2);
      }
      .ok-button {
          background-color: rgb(67, 160, 71) !important;
      }
      .md-dialog-header {
          border-bottom: 0px !important;
      }
    </style>
    <md-dialog-content>
      <div class="md-dialog-header">
        <button class="md-dialog-close" ng-click="cancel()"></button>
        <div class="dialog-content">
        Before proceeding please ensure you are submitting your request through Google Chrome.
        All products will need to have an <a href="https://agcompany.sharepoint.com/:x:/r/sites/TradeGovernanceClassificationTeam/_layouts/15/Doc.aspx?sourcedoc=%7BBC69F20D-7636-4194-9F22-EF144B309CDD%7D&amp=&file=Seeds%20Global%20Logistics%20-%20HTS%20and%20ECCN%20Classifications.xlsx&wdLOR=c8D7C5770-D84B-438A-9F04-2691D7F006C3&_DSL=1&action=default&mobileredirect=true&cid=b6231e0d-2c5b-4055-bc6d-40bc2ee6072a" target="_blank" class="dialog-link">HTS Classification code</a>,
        if product is not listed you will need to email Global Classifications at classify@vylor.com before submitting your request.
        Any asset shipment you will need to work with dl-eotglobalfacs@vylor.com to obtain an asset number and FAMR.
        <a href="https://sprout-ai.vylor.com" target="_blank" class="dialog-link">Sprout Tool</a> is there for any kind of assistance needed.
        If you have questions, email  DL-GlobalShippingSupport@vylor.com.
        </div>
      </div>
    </md-dialog-content>
    <md-dialog-actions>
      <md-button ng-click="cancel()">CANCEL</md-button>
      <md-button class="ok-button" ng-click="ok();">OK</md-button>
    </md-dialog-actions>
  </md-dialog>
`;

        return this.$mdDialog.show({
            template: dialogTemplate,
            controller: function ($scope, $mdDialog) {
                $scope.ok = function () {
                    $mdDialog.hide();
                };
                $scope.cancel = function () {
                    $mdDialog.cancel();
                };
            },
            controllerAs: 'ctrl'
        }).then(() => {
            // Only navigate when OK is clicked and the dialog is closed successfully
            return this.goToAddRequestState();
        });
    }

    public goToAddRequestState(): angular.IPromise<any> {
        return this._$state.go(addRequestState.name);
    }
    protected getMoreItems(): Promise<RequestField[]> {
        return this._requestlistservice.loadMoreRequestFields();
    }

    protected getItems(): Promise<RequestField[]> {
        
        const transportModeValue = this.selectedTransportMode ? this.selectedTransportMode.tMCode : '';

        

        if (this._userInfoService.getUserInfo().role.indexOf("receiver") >= 0) {

            const userIdReceiverFilter = (this.selectedRequestor !== undefined && this.selectedRequestor !== null)
                ? this.selectedRequestor.rqCode
                : '';
            return this._requestlistservice
                .getRequestFields(transportModeValue, this.searchTerm, true, userIdReceiverFilter);
        } else
            {
            // else case is for all other users who are not for role 'receiver' 2 cases . 1. Search for only user requests 2. Globale Search based on user selection
            return this._requestlistservice
                .getRequestFields(transportModeValue,
                    this.searchTerm,
                    this.isGlobalSearchAllowed,
                    '');

        } 
       
    }

    

    private handleGetTransportModeOptions(options: TransportMode[]) {
        this._transportModes = options;

    }

    private handleGetRequestorOptions(options: Requestor[]) {
        this._requestors = options;

    }


    get transportModes(): TransportMode[] {
        return this._transportModes;
    }

    get requestors(): Requestor[] {
        return this._requestors;
    }

    get isApplyButtonDisabled() :boolean {
       return  this._isApplyButtonDisabled;
    }

    protected findSelected(items: RequestField[]): RequestField {

        if (this._userInfoService.getUserInfo().role.indexOf("receiver") >= 0) {
           
            return this._$state.is(requestDetailEditState.name) && this._$stateParams['trackingId']
                ? _.find(items, r => r.trackingId.toString() === this._$stateParams['trackingId'])
                : items[0];
        } else {
           
            return this._$state.is(requestDetailState.name) && this._$stateParams['trackingId']
                ? _.find(items, r => r.trackingId.toString() === this._$stateParams['trackingId'])
                : items[0];
        }

    }

    
    public toggleSidenav() {
        this._navigationService.toggleSidenav();
    }

    
}

angular.module('deliveryCreate.app').controller('RequestListController', RequestListController);



/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/request/requestList/controllers/requestListController.ts
 **/